export function getElyraUserAgent(version: string): string {
	const runtime = process.versions.bun ? `bun/${process.versions.bun}` : `node/${process.version}`;
	return `elyra/${version} (${process.platform}; ${runtime}; ${process.arch})`;
}
